<template>
  <div id="app">
    <link
        href="../static/styles/main.css"
        rel="stylesheet">

    <page-header-top />
    <page-header />

    <section class="mb-5">
      <router-view />
    </section>
    <page-footer />
  </div>
</template>

<script>
import PageHeader from '@/components/Template/Header.vue'
import PageHeaderTop from '@/components/Template/HeaderTop.vue'
import PageFooter from '@/components/Template/Footer.vue'

export default {
    components: {
        PageHeader,
        PageHeaderTop,
        PageFooter
    },
    data () {
        return {

        }
    }
}
</script>

<style>
.alert-success {
  background-color: rgb(7,59,33);
  color: white !important;
  border-color: rgb(7,59,33) !important;
}
.btn.btn-primary {
  background-color: rgb(76,152,102) !important;
  border-color: rgb(76,152,102) !important;
  color: white;
}
  body a {
      color: rgb(76,152,102) !important;
  }
    body a:hover {
      color: rgb(144,187,144) !important;
  }
    .btn-link:hover {
      color: rgb(144,187,144) !important;
  }
  a.page-link.btn-primary {
      color: white !important;
  }
  .page-item.active .page-link {
      background-color: rgb(144,187,144) !important;
  }
  a.btn.btn-secondary.pull-right {
      color: white !important;
  }
  button.swal-button.swal-button--to_cart {
      background-color: rgb(144,187,144) !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue